<template>
  <div class="md-layout bookprice-menu-selected">
    <div class="md-layout-item md-size-50 title-page" style="min-height: 48px;">
      MANAGE PRICE STUCTURE
    </div>

    <!-- <div class="md-layout-item md-size-50 -button" style="min-height: 48px;"> -->
    <div v-if="isViewBook && isViewPricing" class="md-layout-item md-size-50 -button">
      <md-button
        class="md-raised md-primary"
        v-show="isViewPricing"
        :class="isViewPricing && selected === 'price' ? '' : '-default'"
        @click="onClickMenu('price')"
      >
        PRICE STUCTURE
      </md-button>
      <md-button
        class="md-raised md-primary"
        v-show="isViewBook"
        :class="isViewBook && selected === 'bookprice' ? '' : '-default'"
        @click="onClickMenu('bookprice')"
      >
        BOOK PRICE
      </md-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "menu-selected",

  props: {
    selected: {
      type: String,
      required: true
    }
  },

  computed: {
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isViewBook() {
      if (this.permit.acl["overview"].menus["book-price"]) {
        return this.permit.acl["overview"].menus["book-price"].view;
      }
      return false;
    },
    isViewPricing() {
      if (this.permit.acl["overview"].menus["pricing-list"]) {
        return this.permit.acl["overview"].menus["pricing-list"].view;
      }
      return false;
    }
  },

  data() {
    return {};
  },

  methods: {
    onClickMenu(menu) {
      if (this.isViewBook || this.isViewPricing) {
        this.$emit("clickmenu", menu);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bookprice-menu-selected {
  .md-layout-item {
    margin: 10px 0 0 0 !important;

    &.title-page {
      font-size: 18px;
      font-family: lato;
      font-weight: bold;
      color: #797979;
      padding: 8px 18px 0px;
    }

    &.-button {
      justify-content: flex-end;
      padding-right: 15px;
    }
  }
}
</style>